import React from "react";
import { Row, Col, Typography, Button, Space } from "antd";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { Title } from "../Title/Title";

import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { mockData } from "./mock";
import { FinancingCard } from "~/Modules/FinancingProducts/ProductCard";

import Sector1 from "@assets/KPMG/Sustainable/1.jpg";
import Sector2 from "@assets/KPMG/Sustainable/2.jpg";
import Sector3 from "@assets/KPMG/Sustainable/3.jpg";

export const SustainableFinanceFramework = () => {
  const navigate = useNavigate();
  const financingList: any = [
    {
      step: "01",
      titleLine1: "Multinational Development Banks",
      titleLine2: "Banks",
      image: Sector1,
      // description:
      //   "Comprehensive projects are specifically designed to meet the expanding demands of urbanization for our communities.",
      redirectTo: "/financing-products?type=Concessional Finance",
    },
    {
      step: "02",
      titleLine1: "Commercial Financing",
      titleLine2: " ",
      redirectTo: "/financing-products?type=Commercial Finance",
      image: Sector2,
    },
    {
      step: "03",
      titleLine1: "Others",
      titleLine2: " ",
      // description:
      //   "A wide range of initiatives aimed at expanding, upgrading, and modernizing infrastructure to meet the growing demands.",
      redirectTo: "/financing-products?type=Others",
      image: Sector3,
    },
  ];

  const verifyAndRedirect = (linkInfo: any) => {
    if (linkInfo.title === "Country Priority") {
      navigate("/dashboard#investment-asean");
    } else if (linkInfo.title === "Sector Priority") {
      navigate("/dashboard#investment-across-sector");
    } else if (linkInfo.title === "Commercial Finance") {
      navigate(`/financing-products?type=${linkInfo.title}`);
    } else if (linkInfo.title === "Concessional Finance") {
      navigate(`/financing-products?type=${linkInfo.title}`);
    }
  };

  return (
    <>
      <div className="finance-framework" id="sustainable-finance-framework">
        <Row
          style={{
            background: "rgb(247, 250, 255)",
            padding: "40px 0",
            paddingBottom: 20,
          }}
        >
          <Col lg={2}></Col>
          <Col lg={20} sm={24}>
            <Title
              title="SUSTAINABLE FINANCE FRAMEWORK & OPTIONS​"
              variant={2}
              width={2200}
            />
            <div style={{ paddingLeft: 0 }}>
              <div style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Typography.Text
                  className="textSmall"
                  style={{ color: "#000" }}
                >
                  One-stop hub for accessing and understanding the frameworks
                  and products offered by MDBs. We provide concise descriptions
                  and easy navigation, helping users explore financing options
                  like grants, loans, guarantees, and equity investments. Our
                  goal is to streamline access to MDB resources, promoting
                  informed decision-making and collaboration for global
                  sustainable development.
                </Typography.Text>
              </div>
              <div style={{ paddingBottom: 10 }}>
                <Button
                  type="primary"
                  style={{ height: 32 }}
                  className="btn-primary"
                  onClick={() => navigate("/financing-products")}
                >
                  Explore&nbsp; <Icon icon="akar-icons:arrow-right" />
                </Button>
              </div>
            </div>
            <div>
              <Swiper
                style={{ padding: "20px 40px 40px 40px" }}
                // install Swiper modules
                modules={[Navigation, Pagination, A11y, Autoplay]}
                spaceBetween={40}
                slidesPerView={3}
                navigation={true}
                autoplay={{ delay: 4000, pauseOnMouseEnter: true }}
                // loop={true}
                // loopedSlides={2}
                grabCursor={true}
                pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
              >
                {financingList.map((sector: any, index: number) => (
                  <SwiperSlide style={{ height: "auto" }} key={index}>
                    <div
                      style={{
                        height: "100%",
                        marginLeft: 20,
                        marginRight: 20,
                        minWidth: 300,
                        maxWidth: 300,
                      }}
                    >
                      <Space direction="vertical" size="middle">
                        <div
                          style={{
                            cursor: sector.redirectTo
                              ? "pointer"
                              : "not-allowed",
                          }}
                          onClick={() => {
                            // setSelectedSector(sector.title);
                            if (sector.redirectTo) {
                              navigate(sector.redirectTo);
                            }
                            // navigate(`/investment-hub?sector=${sector.title}`);
                          }}
                        >
                          <div
                            style={{
                              background: "#1E49E2",
                              paddingTop: 10,
                              paddingBottom: 10,
                            }}
                          >
                            <div
                              style={{ textAlign: "right", paddingRight: 20 }}
                            >
                              <Typography.Title
                                level={4}
                                style={{ marginBottom: 0, color: "#fff" }}
                              >
                                {sector.step}
                              </Typography.Title>
                            </div>
                            <div style={{ padding: "0 20px" }}>
                              <Typography.Title
                                level={5}
                                style={{
                                  color: "#fff",
                                  marginBottom: 0,
                                  fontWeight: 500,
                                  fontSize: 16,
                                }}
                              >
                                {sector.titleLine1}
                              </Typography.Title>
                              {/* <Typography.Title
                                level={4}
                                style={{
                                  color: "#fff",
                                  marginBottom: 0,
                                  marginTop: 0,
                                }}
                              >
                                {sector.titleLine2}
                              </Typography.Title> */}
                            </div>
                          </div>
                          <div>
                            <div
                              style={{ position: "relative", maxWidth: 300 }}
                            >
                              <img
                                src={sector.image}
                                style={{
                                  maxWidth: "100%",
                                  width: "100%",
                                  height: 240,
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </Space>
                    </div>
                    {/* </Col> */}
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <div style={{ paddingBottom: 20, display: "none" }}>
              <div
                style={{
                  background:
                    "linear-gradient(89.96deg, #003087 0.03%, rgba(253, 52, 156, 0) 98.14%)",
                  padding: "4px 12px",
                  marginBottom: 20,
                  marginTop: 10,
                }}
              >
                <Typography.Title
                  style={{
                    color: "#fff",
                    fontWeight: 500,
                    marginBottom: 0,
                  }}
                  level={4}
                >
                  Multinational Development Banks
                </Typography.Title>
              </div>
              <Row gutter={[32, 32]}>
                {mockData.MDB.map((data: any, index: number) => (
                  <Col span={8}>
                    <FinancingCard data={data} key={index} />
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          <Col lg={2}></Col>
        </Row>
      </div>
    </>
  );
};
